import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "chicago-metro",
    name: "Chicago Metro",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Chicago Core & Lakefront",
        description: "The Loop, Gold Coast, Lincoln Park, Wicker Park, and the South Shore. O'Hare International (ORD) is northwest on the Blue Line; Midway (MDW) is southwest on the Orange Line. Both are accessible via CTA.",
        hub: { name: "Chicago", route: "#" },
        communities: [
          { name: "Lincoln Park", route: "#" }, { name: "Lakeview", route: "#" },
          { name: "Wicker Park", route: "#" }, { name: "Bucktown", route: "#" },
          { name: "Gold Coast", route: "#" }, { name: "Old Town", route: "#" },
          { name: "River North", route: "#" }, { name: "Streeterville", route: "#" },
          { name: "South Shore", route: "#" }, { name: "Hyde Park", route: "#" },
          { name: "Kenwood", route: "#" }, { name: "Bronzeville", route: "#" },
          { name: "Bridgeport", route: "#" }, { name: "Pilsen", route: "#" },
          { name: "Little Italy", route: "#" }, { name: "Greektown", route: "#" },
        ],
      },
      {
        name: "North Shore & Lake County",
        description: "Evanston, Skokie, Wilmette, Winnetka, and Glencoe are the North Shore. Lake Forest, Highland Park, and Waukegan are in Lake County. The Metra Union Pacific North Line connects to Chicago.",
        hub: { name: "Evanston", route: "#" },
        communities: [
          { name: "Skokie", route: "#" }, { name: "Wilmette", route: "#" },
          { name: "Winnetka", route: "#" }, { name: "Glencoe", route: "#" },
          { name: "Kenilworth", route: "#" }, { name: "Northfield", route: "#" },
          { name: "Glenview", route: "#" }, { name: "Northbrook", route: "#" },
          { name: "Highland Park", route: "#" }, { name: "Lake Forest", route: "#" },
          { name: "Waukegan", route: "#" }, { name: "Gurnee", route: "#" },
          { name: "Vernon Hills", route: "#" }, { name: "Libertyville", route: "#" },
          { name: "Deerfield", route: "#" }, { name: "Lincolnshire", route: "#" },
        ],
      },
      {
        name: "West & Northwest Suburbs",
        description: "Schaumburg, Arlington Heights, Palatine, Des Plaines, and Oak Park are the west/northwest suburbs. The I-290, I-90, and the Jane Addams Tollway are the major corridors. Oak Park is on the Blue Line.",
        hub: { name: "Schaumburg", route: "#" },
        communities: [
          { name: "Arlington Heights", route: "#" }, { name: "Palatine", route: "#" },
          { name: "Des Plaines", route: "#" }, { name: "Oak Park", route: "#" },
          { name: "River Forest", route: "#" }, { name: "Forest Park", route: "#" },
          { name: "Elmwood Park", route: "#" }, { name: "Melrose Park", route: "#" },
          { name: "Maywood", route: "#" }, { name: "Berwyn", route: "#" },
          { name: "Cicero", route: "#" }, { name: "Stickney", route: "#" },
          { name: "Hoffman Estates", route: "#" }, { name: "Rolling Meadows", route: "#" },
          { name: "Inverness", route: "#" }, { name: "Barrington", route: "#" },
        ],
      },
      {
        name: "Southwest Suburbs",
        description: "Orland Park, Tinley Park, Oak Forest, and Joliet are the southwest corridor. The Metra Rock Island and Heritage Corridor lines connect to Chicago. The I-80 and I-55 are the main highways. Plainfield and Shorewood are growing fast.",
        hub: { name: "Orland Park", route: "#" },
        communities: [
          { name: "Tinley Park", route: "#" }, { name: "Oak Forest", route: "#" },
          { name: "Joliet", route: "#" }, { name: "Plainfield", route: "#" },
          { name: "Shorewood", route: "#" }, { name: "Romeoville", route: "#" },
          { name: "Bolingbrook", route: "#" }, { name: "Lemont", route: "#" },
          { name: "Lockport", route: "#" }, { name: "New Lenox", route: "#" },
          { name: "Mokena", route: "#" }, { name: "Frankfort", route: "#" },
          { name: "Manhattan", route: "#" }, { name: "Homer Glen", route: "#" },
          { name: "Palos Heights", route: "#" }, { name: "Palos Hills", route: "#" },
        ],
      },
    ],
  },
  {
    id: "dupage-kane",
    name: "DuPage & Kane County",
    icon: "ri-map-2-line",
    subregions: [
      {
        name: "DuPage County",
        description: "Naperville, Wheaton, Elmhurst, Downers Grove, and Glen Ellyn. The I-88 and I-355 are the major corridors. The Metra BNSF and Union Pacific West lines connect to Chicago. The Morton Arboretum is the landmark.",
        hub: { name: "Naperville", route: "#" },
        communities: [
          { name: "Wheaton", route: "#" }, { name: "Elmhurst", route: "#" },
          { name: "Downers Grove", route: "#" }, { name: "Glen Ellyn", route: "#" },
          { name: "Carol Stream", route: "#" }, { name: "Bloomingdale", route: "#" },
          { name: "Roselle", route: "#" }, { name: "Lombard", route: "#" },
          { name: "Villa Park", route: "#" }, { name: "Addison", route: "#" },
          { name: "Bensenville", route: "#" }, { name: "Wood Dale", route: "#" },
          { name: "Itasca", route: "#" }, { name: "Lisle", route: "#" },
          { name: "Warrenville", route: "#" }, { name: "West Chicago", route: "#" },
        ],
      },
      {
        name: "Kane County",
        description: "Aurora, Elgin, and St. Charles are the Kane County core. The I-88 and I-90 are the major corridors. The Metra Union Pacific West Line connects to Chicago. The Fox River runs through the county.",
        hub: { name: "Aurora", route: "#" },
        communities: [
          { name: "Elgin", route: "#" }, { name: "St. Charles", route: "#" },
          { name: "Geneva", route: "#" }, { name: "Batavia", route: "#" },
          { name: "South Elgin", route: "#" }, { name: "Bartlett", route: "#" },
          { name: "North Aurora", route: "#" }, { name: "Montgomery", route: "#" },
          { name: "Oswego", route: "#" }, { name: "Sugar Grove", route: "#" },
          { name: "Big Rock", route: "#" }, { name: "Maple Park", route: "#" },
          { name: "Kaneville", route: "#" }, { name: "Burlington", route: "#" },
          { name: "Hampshire", route: "#" }, { name: "Pingree Grove", route: "#" },
        ],
      },
    ],
  },
  {
    id: "central-southern",
    name: "Central & Southern Illinois",
    icon: "ri-landscape-line",
    subregions: [
      {
        name: "Central Illinois",
        description: "Springfield, the state capital, plus Peoria, Champaign, Bloomington, and Normal. The University of Illinois Urbana-Champaign is the major institution. The I-55, I-74, and I-57 are the major corridors.",
        hub: { name: "Springfield", route: "#" },
        communities: [
          { name: "Peoria", route: "#" }, { name: "Champaign", route: "#" },
          { name: "Bloomington", route: "#" }, { name: "Normal", route: "#" },
          { name: "Decatur", route: "#" }, { name: "Urbana", route: "#" },
          { name: "Savoy", route: "#" }, { name: "Manteno", route: "#" },
          { name: "Mahomet", route: "#" }, { name: "Monticello", route: "#" },
          { name: "Chatham", route: "#" }, { name: "Rochester", route: "#" },
          { name: "Sherman", route: "#" }, { name: "Riverton", route: "#" },
          { name: "Pawnee", route: "#" }, { name: "Williamsville", route: "#" },
        ],
      },
      {
        name: "Southern Illinois",
        description: "Carbondale, home of Southern Illinois University, plus Belleville, Alton, and Quincy. The Shawnee National Forest is the major landmark. The Mississippi River forms the western border. The I-64 and I-57 are the main corridors.",
        hub: { name: "Carbondale", route: "#" },
        communities: [
          { name: "Belleville", route: "#" }, { name: "Alton", route: "#" },
          { name: "Quincy", route: "#" }, { name: "Murphysboro", route: "#" },
          { name: "Marion", route: "#" }, { name: "Herrin", route: "#" },
          { name: "Carterville", route: "#" }, { name: "O'Fallon", route: "#" },
          { name: "Fairview Heights", route: "#" }, { name: "Edwardsville", route: "#" },
          { name: "Godfrey", route: "#" }, { name: "East Alton", route: "#" },
          { name: "Hannibal MO area", route: "#" }, { name: "Mount Vernon", route: "#" },
          { name: "Centralia", route: "#" }, { name: "Salem", route: "#" },
        ],
      },
      {
        name: "Western Illinois & Quad Cities",
        description: "Moline, Rock Island, Galesburg, and the Quad Cities area. The Mississippi River forms the border with Iowa. The I-74, I-80, and I-88 are the major corridors. The John Deere headquarters is in Moline.",
        hub: { name: "Moline", route: "#" },
        communities: [
          { name: "Rock Island", route: "#" }, { name: "Galesburg", route: "#" },
          { name: "Davenport IA", route: "#" }, { name: "Bettendorf IA", route: "#" },
          { name: "East Moline", route: "#" }, { name: "Milan", route: "#" },
          { name: "Silvis", route: "#" }, { name: "Colona", route: "#" },
          { name: "Hampton", route: "#" }, { name: "Kewanee", route: "#" },
          { name: "Monmouth", route: "#" }, { name: "Macomb", route: "#" },
          { name: "Jacksonville", route: "#" }, { name: "Beardstown", route: "#" },
          { name: "Rushville", route: "#" }, { name: "Canton", route: "#" },
        ],
      },
    ],
  },
  {
    id: "northern",
    name: "Northern Illinois",
    icon: "ri-compass-line",
    subregions: [
      {
        name: "Rockford & DeKalb",
        description: "Rockford is the largest city outside the Chicago metro. DeKalb is home to Northern Illinois University. The I-90 and US-20 are the major corridors. The I-39 connects to the Wisconsin border.",
        hub: { name: "Rockford", route: "#" },
        communities: [
          { name: "DeKalb", route: "#" }, { name: "Sycamore", route: "#" },
          { name: "Cortland", route: "#" }, { name: "Genoa", route: "#" },
          { name: "Malta", route: "#" }, { name: "Kingston", route: "#" },
          { name: "Loves Park", route: "#" }, { name: "Machesney Park", route: "#" },
          { name: "Belvidere", route: "#" }, { name: "Poplar Grove", route: "#" },
          { name: "Cherry Valley", route: "#" }, { name: "Roscoe", route: "#" },
          { name: "South Beloit", route: "#" }, { name: "Davis Junction", route: "#" },
          { name: "Byron", route: "#" }, { name: "Stillman Valley", route: "#" },
        ],
      },
    ],
  },
];

export default function IllinoisCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);

  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across Illinois
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don't see your city in the directory above? You're still covered. Every Illinois community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                <a
                  href={sub.hub.route}
                  className="flex-shrink-0 inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap"
                >
                  Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                </a>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  <a
                    key={j}
                    href={c.route}
                    className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap cursor-pointer"
                  >
                    {c.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community? <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">Call us at 877-253-0084</a> — we serve all of Illinois.
        </p>
      </div>
    </section>
  );
}